export interface IbanDetails {
  bic: string;
  bank: string;
  sepa: boolean;
}
